export var BettingOptionStatus;
(function (BettingOptionStatus) {
    BettingOptionStatus["WON"] = "won";
    BettingOptionStatus["LOST"] = "lost";
    BettingOptionStatus["ACTIVE"] = "active";
    BettingOptionStatus["PUSH"] = "push";
    BettingOptionStatus["INACTIVE"] = "inactive";
})(BettingOptionStatus || (BettingOptionStatus = {}));
